import React, { useState } from 'react';
import { Box, Button, FormControl, Grid, RadioGroup, Typography } from '@mui/material';
import { inputsBox, sendBtn } from './EmployeeAddPage.sx';
import CustomInput from 'app/components/CustomInput';
import useEmployeeAddPage from './useEmployeeAddPage';
import PageHeader from 'app/components/PageHeader';
import CustomRadio from 'app/components/CustomRadio';
import logger from 'app/utils/logger';
import { Controller } from 'react-hook-form';
import CustomSelect from 'app/components/CustomSelect';
import CustomSnackbar from 'app/components/CustomSnackbar';
import SuccessModal from 'app/components/SuccessModal';
import FieldError from 'app/components/FieldError';

interface Props {
  edit?: boolean;
  userData?: any;
  rulesData?: any;
  employeeList?: any;
  businessKey?: any;
}

const EmployeeAddPage = (props: Props) => {
  const { edit, userData, rulesData, employeeList, businessKey } = props;
  const {
    register,
    control,
    handleSend,
    autostatement_types,
    selectedAutoStatementPeriod,
    handleChangeAutoStatementPeriod,
    position,
    dataEmployeeUpsert,
    openSnackbar,
    setOpenSnackbar,
    setOpenSuccessModal,
    openSuccesModal,
    submitForm,
    phoneInput,
    handleOnChangePhone,
    errors,
    finInput,
    handleFin,
    handleChangeFname,
    handleChangeSurname,
    handleChangeName,
    nameInput,
    fnameInput,
    surnameInput,
    emailInput,
    handleEmail,
  } = useEmployeeAddPage({ edit, userData, rulesData, employeeList, businessKey });

  return (
    <>
      <PageHeader back={true} pageName={edit ? 'Düzəliş' : 'Yeni əməkdaş əlavə et'} />
      <form onSubmit={submitForm}>
        <Box sx={inputsBox}>
          <Grid sx={{ width: '700px' }} container rowSpacing="16px">
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'Soyad'}
                  placeholder={'Soyad'}
                  rest={{ ...register('surname') }}
                  value={surnameInput}
                  handleChange={handleChangeSurname}
                />
                <FieldError error={errors.surname} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'Ad'}
                  placeholder={'Ad'}
                  rest={{ ...register('name') }}
                  value={nameInput}
                  handleChange={handleChangeName}
                />
                <FieldError error={errors.name} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'Ata adı'}
                  placeholder={'Ata adı'}
                  rest={{ ...register('fname') }}
                  value={fnameInput}
                  handleChange={handleChangeFname}
                />
                <FieldError error={errors.fname} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomSelect
                  title={'Vəzifə'}
                  placeholder={'Vəzifə'}
                  disabled={true}
                  rest={{ ...register('position') }}
                  options={employeeList}
                  optionValue={true}
                  valueOption={'id'}
                  optionLabel={true}
                  labelOption={'title'}
                  value={position}
                  control={control}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'Fin kod'}
                  placeholder={'Fin kod'}
                  rest={{ ...register('fin'), maxLength: 7 }}
                  value={finInput}
                  handleChange={handleFin}
                />
                <FieldError error={errors.fin} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'E-mail'}
                  placeholder={'E-mail'}
                  rest={{ ...register('email') }}
                  value={emailInput}
                  handleChange={handleEmail}
                />
                <FieldError error={errors.email} />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <CustomInput
                  title={'Mobil nömrə'}
                  placeholder={'Mobil nömrə'}
                  rest={{ ...register('phone') }}
                  adornmentStart={<Typography>+994</Typography>}
                  value={phoneInput}
                  handleChange={handleOnChangePhone}
                />
                <FieldError error={errors.phone} />
              </FormControl>
            </Grid>
          </Grid>
          <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>İcazələr</Typography>
          <Grid sx={{ width: '700px' }} container rowSpacing="32px">
            {autostatement_types.map((item, index) => (
              <Grid key={item.title} item xs={6}>
                <Box sx={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
                  <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>{item.title}</Typography>
                  <Controller
                    render={({ field }) => (
                      <RadioGroup
                        sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
                        value={selectedAutoStatementPeriod[item.label]}
                        {...field}
                      >
                        {item.types.map((subItem) => (
                          <CustomRadio
                            title={subItem.title}
                            value={selectedAutoStatementPeriod[item.label]}
                            checked={selectedAutoStatementPeriod[item.label] === subItem.value}
                            key={subItem.title}
                            handleChange={() => handleChangeAutoStatementPeriod(item.label, subItem.value)}
                            mr={'8px'}
                            // rest={{ ...register(item.title) }}
                            // isValid={errors?.periodicity !== undefined}
                            control={control}
                            disabled={item.label === 'profile' || item.label === 'trn_sign'}
                          />
                        ))}
                      </RadioGroup>
                    )}
                    name={'rules'}
                    control={control}
                    defaultValue={selectedAutoStatementPeriod[item.label]}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box sx={{ display: 'flex', width: '100%', marginTop: '16px', justifyContent: 'right' }}>
          <Button type={'submit'} color={'tertiary'} sx={sendBtn}>
            Yadda saxla
          </Button>
        </Box>
        {dataEmployeeUpsert?.error !== undefined ? (
          <CustomSnackbar
            open={openSnackbar}
            setOpen={setOpenSnackbar}
            hideDuration={5000}
            type={dataEmployeeUpsert?.error !== undefined ? dataEmployeeUpsert?.error.type : dataEmployeeUpsert?.type}
            text={dataEmployeeUpsert?.error !== undefined ? dataEmployeeUpsert?.error.text : dataEmployeeUpsert?.text}
          />
        ) : edit ? (
          <CustomSnackbar
            open={openSnackbar}
            setOpen={setOpenSnackbar}
            hideDuration={5000}
            type={dataEmployeeUpsert?.error !== undefined ? dataEmployeeUpsert?.error.type : dataEmployeeUpsert?.type}
            text={dataEmployeeUpsert?.error !== undefined ? dataEmployeeUpsert?.error.text : dataEmployeeUpsert?.text}
          />
        ) : (
          <SuccessModal
            open={openSuccesModal}
            close={setOpenSuccessModal}
            successText={'İşçinin əlavə edilməsi ilə bağlı məlumatlar qeyd etdiyiniz e-mail ünvanına göndərildi!'}
            path={'/az/home-page'}
          />
        )}
      </form>
    </>
  );
};

export default EmployeeAddPage;
